import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['AggregationInterval'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAggregationIntervalById: build.query<GetAggregationIntervalByIdApiResponse, GetAggregationIntervalByIdApiArg>({
        query: (queryArg) => ({ url: `/AggregationInterval/${queryArg}` }),
        providesTags: ['AggregationInterval'],
      }),
      getAggregationIntervalGetAll: build.query<
        GetAggregationIntervalGetAllApiResponse,
        GetAggregationIntervalGetAllApiArg
      >({
        query: () => ({ url: `/AggregationInterval/get-all` }),
        providesTags: ['AggregationInterval'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as aggregationIntervalApi };
export type GetAggregationIntervalByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoAggregationIntervalExternalDto;
export type GetAggregationIntervalByIdApiArg = number;
export type GetAggregationIntervalGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoAggregationIntervalExternalDto;
export type GetAggregationIntervalGetAllApiArg = void;
export type ApiCommonExternalDtoAggregationIntervalExternalDto = {
  id?: number;
  name: string;
  technicalName: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoAggregationIntervalExternalDto = {
  externalDto?: ApiCommonExternalDtoAggregationIntervalExternalDto;
  externalDtos?: ApiCommonExternalDtoAggregationIntervalExternalDto[] | null;
};
export const {
  useGetAggregationIntervalByIdQuery,
  useLazyGetAggregationIntervalByIdQuery,
  useGetAggregationIntervalGetAllQuery,
  useLazyGetAggregationIntervalGetAllQuery,
} = injectedRtkApi;
